// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconCopy = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M45.9469 53.6144C46.2243 54.9969 45.3947 55.9999 43.9846 55.9999H14.0935C13.0348 55.9999 12.351 55.4495 12.1364 54.4127C11.1254 49.5278 8.38881 38.85 8.00026 22.0344C7.97164 20.7946 8.76229 20.0186 10.0025 20.0186H16.5136C17.3427 30.0488 18.9603 37.0585 20.5434 44.7963C20.9243 46.6582 22.5617 47.9999 24.4621 47.9999H44.7329C45.203 50.2123 45.6391 52.0812 45.9469 53.6144ZM57.9469 41.6143C56.8172 35.9859 53.973 26.0092 53.973 10.0066C53.973 8.77856 53.2035 8.01855 51.9755 8.01855H22.0025C20.7623 8.01855 19.9716 8.79449 20.0003 10.0343C20.3889 26.8499 23.1254 37.5278 24.1364 42.4127C24.351 43.4494 25.0348 43.9999 26.0935 43.9999H55.9846C57.3947 43.9999 58.2243 42.9969 57.9469 41.6143Z" />
    </svg>
  );
};
